import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Headers, RequestOptions, Response } from '@angular/http';
import { Router } from '@angular/router';
import { SessionStorage } from 'ngx-webstorage';
import { HttpService } from '../../../utils/services/http.service';
import { ErrorsService } from '../../../utils/services/errors.service';

@Injectable()
export class AddEmployeeService {
  @SessionStorage() public user;
  constructor(private httpService: HttpService,
    private errorsService: ErrorsService) { }

  saveEmployee(data) {
    return this.httpService.post(`employee`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  uploadCSV(activity: any): Observable<any> {
    const headers = new Headers();
    headers.append('Accept', 'application/json, text/csv,');
    headers.append('Empname', this.user.Empname);
    headers.append('EmailID', this.user.EmailID);
    const options = new RequestOptions({ headers: headers });
    return this.httpService.post(`employee`, activity, options)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  uploadIpdoCSV(activity: any): Observable<any> {
    const headers = new Headers();
    headers.append('Accept', 'application/json, text/csv,');
    headers.append('Empname', this.user.Empname);
    headers.append('EmailID', this.user.EmailID);
    const options = new RequestOptions({ headers: headers });
    return this.httpService.post(`employeeCsvUpdate`, activity, options)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  getrmList(): Observable<any> {
    const data = { 'role': 'RM' };
    return this.httpService.post(`delegation/listemployees`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  uploadHistory(businessUnit) {
    if (businessUnit == 'accenture') {
      const data = { 'type': 'employee' };
      return this.httpService.post(`listfileUploadHist`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
    } else if (businessUnit == 'ipdo' || businessUnit == 'biologics' || businessUnit == 'chinateam' || businessUnit == 'aps') {
      const data = { 'type': 'updateEmployee' };
      return this.httpService.post(`listfileUploadHist`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
    }
  }

  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/employees/add-employee/add-employee.service.ts